import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const fetchJobs = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.JOB_ENDPOINT + '/fetchJobs', payload, token);
        return response;
    } catch (err) {
        console.log("Error in fetchJobs service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}


export const createJob = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.JOB_ENDPOINT + '/createJob', payload, token);
        return response;
    } catch (err) {
        console.log("Error in createJob service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const updateJob = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.JOB_ENDPOINT + '/updateJob', payload, token);
        return response;
    } catch (err) {
        console.log("Error in updateJob service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const deleteJob = async (payload) => {
    try {
        const token = getToken();
        const { id } = payload;
        const response = await apiService.deleteData(API_URL.JOB_ENDPOINT + `/deleteJob/${id}`, token);
        return response;
    } catch (err) {
        console.log("Error in deleteJob service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}